import { FaqSchemaItem, toFaqList } from '../../builders/faq'

export const aiDrivenDevelopmentFaqItems: FaqSchemaItem[] = [
  {
    question: '開発AIエージェントとは何ですか？ 従来のコード補完ツールとの違いは？',
    answer:
      'Github CopilotやGeminiなどの汎用 LLM を"開発タスク特化"で包んだ自律エージェントです。IDE・ターミナル・ブラウザを内蔵し、①リポジトリ読解 → ②タスク分解 → ③コーディング／テスト → ④プルリク作成までを半自動化します。',
  },
  {
    question: '社内に開発経験者が少なくても、スクラムは導入できますか？',
    answer:
      'はい、可能です。当社のスクラムマスターが伴走しながら、段階的にスクラム開発のプロセスを導入していきます。 開発経験者が少ない場合は、当社のエンジニアがチームに加わり、技術面でのサポートも行いながら、 社内メンバーのスキルアップを支援します。経験を積みながら徐々に自走できる体制を構築していきます。',
  },
  {
    question: '現在オンプレ環境で運用していますが、クラウド移行は必須ですか？',
    answer:
      'クラウド移行は必須ではありません。お客様の状況や要件に合わせて最適な環境を提案いたします。 ただし、内製化を進める上でのスピードや柔軟性を考慮すると、クラウド環境の活用がメリットをもたらすケースが多いです。 オンプレミスとクラウドのハイブリッド構成や、段階的な移行計画など、お客様に最適な方法をご提案いたします。',
  },
  {
    question: '開発環境等のセキュリティーが厳しいですが対応可能ですか？',
    answer:
      'はい、厳格なセキュリティ要件にも対応可能です。金融機関など高いセキュリティが求められる業界での 支援実績も豊富にございます。お客様のセキュリティポリシーに準拠した開発環境の構築や、 セキュアなCI/CDパイプラインの実装、コードレビューやセキュリティテストの自動化など、 セキュリティを担保しながら効率的な開発を実現するための支援を行います。',
  },
  {
    question: '開発体制の拡張は可能ですか？',
    answer:
      'はい、プロジェクトの進行状況や要件の変化に応じて、柔軟に開発体制を拡張することが可能です。 当社の独自人材DB（Eland）には、様々な技術スタックに精通したエンジニアが登録されており、 必要に応じて適切なスキルを持つ人材をアサインすることができます。 また、複数のスクラムチームの編成や、特定の専門領域（UX/UI、インフラ、セキュリティなど）に 特化したエキスパートの追加など、プロジェクトのニーズに合わせた体制構築をサポートします。',
  },
]

export const aiDrivenDevelopmentFaqList = toFaqList(
  'よくあるご質問',
  'AI駆動開発支援に関するよくあるご質問にお答えします',
  aiDrivenDevelopmentFaqItems,
)
